import * as React from 'react';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { GlobalPrivateState, NavigationConfigurationKeys, ApronBackSplashKeys, formatMessage } from 'src/api';
import { Accordion } from 'src/app/Container/Accordion/Accordion';
import { ConfigurationHeader, ConfigurationPartProps, ConfigurationPart } from 'src/app/Partials';

import { 
  ConfigurationModel, 
  ApronBackSplashDefaultModel, 
} from 'franke-trough-dependencies';

import {
  Apron,
  SurgeEdgeBacksplash,
  ElementNext,
} from 'src/app/Partials/Configuration/Inputs';

import MESSAGES from '../ConfigurationDetail.messages';

import './ConfigurationApronBacksplash.page.scss';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ConfigurationApronBacksplashProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  validated: GlobalPrivateState['validatedConfiguration'];
}

export class ConfigurationApronBacksplash extends React.Component<ConfigurationApronBacksplashProps> {
  componentDidMount() {
    this.dispatchDefaults();
  }
  
  shouldComponentUpdate() {
    const { configuration } = this.props;
    return !configuration.result ? true : false;
  }

  public render() {
    return (
      <div className="page-configuration-apron-backsplash">
          <div className="col-12">
            <ConfigurationHeader
              icon="apron-backsplash"
              title={formatMessage(MESSAGES.apronTitle)}
            />
          </div>
          <div className="configuration-wrap pl-5 pr-5 pt-1">
            <div className="col-12 pb-3 pl-0 pr-0">
              <Accordion>
                {this.apronBacksplashParts.map((props, index) => {
                  const key = `configuration_apron_back_splash_${index}`;
                  return (
                    <ConfigurationPart
                      key={key}
                      {...props}
                    />
                  );
                })}
              </Accordion>
            </div>
            <div className="col-12 pt-4 text-center">
              <ElementNext id={NavigationConfigurationKeys.apronBackSplash} />
            </div>
          </div>
      </div>
    );
  }

  private get apronBacksplashParts(): ConfigurationPartProps[] {
    const validated = this.props.validated.byItem.apronBackSplash;    
    return [{
      btnName: formatMessage(MESSAGES.apron),
      component: Apron,
      error: [
        validated && validated.apron || false,
        validated && validated.apronHeight || false,
      ] || undefined,
      id: ApronBackSplashKeys.Apron,
    }, {
      btnName: formatMessage(MESSAGES.surgeEdgeOrBackSplash),
      component: SurgeEdgeBacksplash,
      error: [
        validated && validated.backsplashHeight || false,
        validated && validated.positionOfEdgeOrBacksplash || false,
        validated && validated.surgeEdgeOrBackSplash || false,
      ] || undefined,
      id: ApronBackSplashKeys.SurgeEdgeOrBackSplash,
    }];
  }

  private get defaults(): ApronBackSplashDefaultModel | undefined {
    const { configuration } = this.props;
    const confDefaults = configuration.result && configuration.result && configuration.result.defaults;
    return confDefaults && confDefaults.apronBackSplash;
  }
  
  private dispatchDefaults() {
    const { configuration } = this.props;
    
    if (!isConfigurationEditable()) { return; }

    if (configuration && configuration.result && !configuration.result.apronBackSplash) {
      const defaults = this.defaults;
      if (defaults) {
        const data: ConfigurationModel['apronBackSplash'] = {
          apron: defaults.apron.default,
          // apronHeight: defaults.apronHeight.default,
          surgeEdgeOrBackSplash: defaults.surgeEdgeOrBackSplash.default,
          positionOfEdgeOrBacksplash: defaults.positionOfEdgeOrBacksplash.default,
          backsplashHeight: defaults.backsplashHeight.default,
          restorablePlateDimensions: defaults.restorablePlateDimensions.default
        }; 

        this.props.dispatch(requestAPIActions.load(
          'configuration',
          {
            url: `/Configurations/${configuration.result.id}`,
            options: {
              method: 'PATCH',
              data: {apronBackSplash: data},
            },
          },
          true
        ));
      }
    }
  }

}

export const ConfigurationApronBacksplashPage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration, 
  validated: state.validatedConfiguration,
}))(ConfigurationApronBacksplash);

export default ConfigurationApronBacksplashPage;